import { get, put } from '../Services/http';
import { catchError } from './Error.action';
import { SUGGESTED_PRODUCTS_RECEIVED } from '../constants';

export const loadSuggestedProducts = () => (dispatch) => {
  return get('/api/suggestedProducts')
    .then((response) => response.json())
    .then((suggestedproducts) => {
      dispatch(receive(suggestedproducts));
    })
    .catch((ex) => {
      console.log(ex);
      return error;
    });
};

export const receive = (suggestedproducts) => (dispatch) => {
  return dispatch({
    type: SUGGESTED_PRODUCTS_RECEIVED,
    payload: suggestedproducts,
  });
};
